import * as React from 'react';
import { AuthLoginByOtacHelperContext } from './provider.js';

function useAuthLoginByOtacHelper() {
    const helper = React.useContext(AuthLoginByOtacHelperContext);
    if (helper === null)
        throw new Error('Hook must be used inside AuthLoginByOtacHelperProvider');
    return helper;
}

export { useAuthLoginByOtacHelper };
//# sourceMappingURL=hook.js.map
